import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import './app.scss';
import Footer from './layout/footer';
import Header from './layout/header';
import AppRoute from './route';

// TODO: theme provider yapılacak.

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    dayjs.locale(i18n.language);
  }, []);

  return (
    <div className="app-container">
      <Helmet>
        <title>{t('head_tite')}</title>
      </Helmet>
      <Router>
        <Header />
        <div className="content-container">
          <AppRoute />
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
